module.exports = __webpack_public_path__ + "src/modal/icons/close.a610df829f77a6155a5f80022df0ab54.svg";